import React, { Component } from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import { FieldErrorMessage } from './fieldErrorMessage';
import SystemOnlyBadge, {
  markSystemOnlyOptions
} from '../common/SystemOnlyBadge';

class DropdownInput extends Component {
  onValueChange = (evt, obj) => {
    if (obj.value !== this.props.value) {
      this.props.onChange(evt, obj);
    }
  };

  render() {
    const {
      id,
      label,
      systemOnly,
      inputLabel,
      name,
      subtext,
      required,
      search,
      options,
      validationErrorMessage,
      ...pprops
    } = this.props;

    return (
      <Form.Field id={id} required={required} className={this.props.className}>
        {label && (
          <label>
            {label}
            {systemOnly && <SystemOnlyBadge />}
          </label>
        )}
        <Dropdown
          name={name}
          selection
          disabled={this.props.disabled}
          options={options && markSystemOnlyOptions(options)}
          value={this.props.value}
          onChange={this.onValueChange}
          search={search}
          onFocus={this.props.onFocus}
          text={this.props.value ? null : this.props.defaultLabel}
          {...pprops}
        />
        {subtext && <div className="input-sub">{subtext}</div>}
        <FieldErrorMessage message={validationErrorMessage} />
      </Form.Field>
    );
  }
}

export default DropdownInput;
